<template>
  <div class="flex bg-slate-25 top-4">
    <woot-wizard
      class="small-3 columns p-5"
      :items="$t('IMPORT_WIZARD.STEPS')"
      :step="step"
    />
    <div
      v-if="!getStatusLoading"
      class="wizard-body w-[75%] max-w-[75%] !h-auto pb-0"
    >
      <keep-alive>
        <component :is="stepComponent" />
      </keep-alive>

      <div class="w-full">
        <div class="flex flex-row justify-end gap-2 py-2 px-0 w-full">
          <woot-button
            v-if="step > 0 && step < 3"
            class="button clear"
            @click.prevent="back"
          >
            {{ $t('IMPORT_WIZARD.BACK') }}
          </woot-button>
          <woot-button v-if="step < 2" :is-disabled="!canGoNext" @click="next">
            {{ $t('IMPORT_WIZARD.NEXT') }}
          </woot-button>
          <woot-button v-if="canSubmit" @click="fileUpload">
            {{ $t('IMPORT_WIZARD.SUBMIT') }}
          </woot-button>
          <woot-button v-if="showImportAgainButton" @click="step = 0">
            {{ $t('IMPORT_WIZARD.AGAIN') }}
          </woot-button>
        </div>
      </div>
    </div>
    <spinner v-else class="ml-2" />
  </div>
</template>

<script>
import Spinner from 'shared/components/Spinner.vue';
import { mixin as clickaway } from 'vue-clickaway';
import Step1 from './Step1.vue';
import hasPermissionMixin from 'dashboard/mixins/hasPermission';
import Step2 from './Step2';
import Step3 from './Step3';
import Step4 from './Step4';
import { mapGetters } from 'vuex';

export default {
  components: {
    Step1,
    Step2,
    Step3,
    Step4,
    Spinner,
  },
  mixins: [clickaway, hasPermissionMixin],
  data() {
    return {
      step: 0,
    };
  },
  computed: {
    ...mapGetters({
      getStatusLoading: 'importWizard/getStatusLoading',
      getIboxId: 'importWizard/getIboxId',
      getFile: 'importWizard/getFile',
      validMapping: 'importWizard/validMapping',
      getStatusInfo: 'importWizard/getStatusInfo',
    }),
    stepComponent() {
      switch (this.step) {
        case 1:
          return Step2;
        case 2:
          return Step3;
        case 3:
          return Step4;
        default:
          return Step1;
      }
    },
    canSubmit() {
      return this.getIboxId && this.step === 2;
    },
    canGoNext() {
      if (this.step === 0 && this.getFile) return true;
      if (this.step === 1 && this.validMapping) return true;
      return false;
    },
    showImportAgainButton() {
      return (
        this.step === 3 &&
        ['completed', 'failed'].includes(this.getStatusInfo?.status)
      );
    },
  },
  async mounted() {
    await this.fetchStatus();
  },
  methods: {
    next() {
      this.step += 1;
    },
    back() {
      this.step -= 1;
      this.fileReady = false;
    },
    async fileUpload() {
      await this.$store.dispatch('importWizard/import');
      this.fetchStatus();
    },
    async fetchStatus() {
      await this.$store.dispatch('importWizard/importStatus');
      if (this.getStatusInfo?.status) {
        this.step = 3;
      }
    },
  },
};
</script>

<style scoped lang="scss">
.basic-filter {
  @apply w-52 p-4 top-6;
}
.wizard-body {
  padding-top: 3em;
}
</style>
